import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-navlist', 'MY_SHORTCUTS', 'My shortcuts');
Labels.set('ui-navlist', 'REMOVE_SHORTCUT', 'Delete shortcut');
Labels.set('ui-navlist', 'ADD_SHORTCUT', 'Add shortcut');
Labels.set('ui-navlist', 'EDIT_SHORTCUTS', 'Edit shortcuts');
Labels.set('ui-navlist', 'FINISH_EDITING', 'Finish editing');
Labels.set('ui-navlist', 'BACK', 'Back');
